// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionMobileStyle: 'style2',
		suggestionPosition: 'left',
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

	jQ('.search-button').on('click', function() {
		setTimeout(function() {
			jQ('.boost-pfs-search-suggestion-wrapper, .boost-pfs-search-suggestion-mobile-overlay, .boost-pfs-search-suggestion-mobile-top-panel').remove();
			boostPFS.initSearchBox();
		}, 500);
	});

	InstantSearch.prototype.beforeInit = function () {
        jQ('#search-results').attr("style", "display: none !important");
    };
})();